import { render } from "./index copy.vue?vue&type=template&id=0614379a&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"

import "./index copy.vue?vue&type=style&index=0&id=0614379a&scoped=true&lang=css"
import "./index copy.vue?vue&type=style&index=1&id=0614379a&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0614379a"]])

export default __exports__